import { ArrowUpRight, Check } from "lucide-react";
import { Reveal, Label } from "./motion";
import { SERVICES } from "../data";

export const Services = () => (
  <section id="services" className="px-4 md:px-8 lg:px-12 py-24 md:py-32 lg:py-48" data-testid="services-section">
    <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-16">
      <div>
        <Reveal><Label>03 — Services</Label></Reveal>
        <Reveal delay={0.1}>
          <h2 className="font-display text-5xl sm:text-6xl lg:text-8xl leading-none mt-6 text-white">
            Ways we<br />can work
          </h2>
        </Reveal>
      </div>
      <Reveal delay={0.2}>
        <p className="text-zinc-400 max-w-sm text-base lg:text-lg">
          Every path starts with a free consultation. No pressure, no contracts — just a conversation about your goals.
        </p>
      </Reveal>
    </div>

    <div className="grid md:grid-cols-3 gap-6">
      {SERVICES.map((s, i) => (
        <Reveal key={s.title} delay={i * 0.1}>
          <div
            data-testid={`service-card-${i}`}
            className={`group h-full p-8 lg:p-10 border transition-colors flex flex-col ${
              s.featured
                ? "bg-[#FF3B30] border-[#FF3B30] text-white"
                : "bg-[#121212] border-zinc-800 hover:border-zinc-600 text-white"
            }`}
          >
            <div className="flex items-start justify-between">
              <span className={`font-display text-2xl ${s.featured ? "text-white/60" : "text-zinc-600"}`}>0{i + 1}</span>
              <ArrowUpRight className={`${s.featured ? "text-white" : "text-zinc-600 group-hover:text-[#FF3B30]"} transition-colors`} size={28} />
            </div>
            <h3 className="font-display text-3xl lg:text-4xl mt-8 leading-none">{s.title}</h3>
            <p className={`mt-4 leading-relaxed ${s.featured ? "text-white/90" : "text-zinc-400"}`}>{s.desc}</p>
            <ul className="mt-8 space-y-3 pt-6 border-t border-white/15">
              {s.points.map((p) => (
                <li key={p} className="flex items-center gap-3 text-sm">
                  <Check size={16} className={s.featured ? "text-white" : "text-[#FF3B30]"} />
                  <span className={s.featured ? "text-white/90" : "text-zinc-300"}>{p}</span>
                </li>
              ))}
            </ul>
          </div>
        </Reveal>
      ))}
    </div>
  </section>
);
